import React, { useEffect, useState } from "react";
import "./style.css";
import CustomDropdown from "../CustomDropdown";
import api from "../../services/axios";
import { useAuth } from "../../context/AuthContext";

const days = [
  { value: "Select", label: "Select" },
  { value: "today", label: "Today" },
  { value: 7, label: "Last 7 Days" },
  { value: 30, label: "30 Days" },
  { value: 180, label: "6 Months" },
  { value: 365, label: "12 Months" },
  { value: "ALL", label: "ALL" },
];

export default function AssistVia() {
  const [applications, setApplications] = useState([]);
  const [rawTicketData, setRawTicketData] = useState([]);
  const [appMap, setAppMap] = useState({});
  const [selectedDays, setSelectedDays] = useState("Select");

  const { authUser } = useAuth();

  const handleChange = (value) => {
    setSelectedDays(value);
    console.log("Select day range:", value);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const { data: appData } = await api.post("/Application_Types", {});
        const apps = Array.isArray(appData?.data) ? appData.data : [];

        const map = {};
        apps.forEach(({ Id, DisplayName }) => {
          map[Id] = DisplayName;
        });
        setAppMap(map);
        const { data: ticketDataRes } = await api.post("/list_ticket");
        // const { data: ticketDataRes } = await api.post("/list_ticket", {
        //   isAdmin: authUser.isAdmin,
        //   Code: authUser.Code,
        // });
        const tickets = Array.isArray(ticketDataRes?.data) ? ticketDataRes.data : [];
        setRawTicketData(tickets);
      } catch (e) {
        console.error("Error fetching data:", e);
        setRawTicketData([]);
        setApplications([]);
      }
    }
    fetchData();
  }, [authUser?.isAdmin, authUser?.Code]);

  useEffect(() => {
    if (!rawTicketData.length || !Object.keys(appMap).length) {
      setApplications([]);
      return;
    }

    const now = new Date();
    let cutoffDate = null;

    if (selectedDays !== "Select") {
      cutoffDate =
        selectedDays === "today"
          ? new Date(now.getFullYear(), now.getMonth(), now.getDate())
          : new Date(now.getTime() - selectedDays * 24 * 60 * 60 * 1000);
    }

    const ticketCountMap = {};
    const ticketNoSetMap = {};

    Object.keys(appMap).forEach((appId) => {
      ticketCountMap[appId] = 0;
      ticketNoSetMap[appId] = new Set();
    });

    rawTicketData.forEach(({ Application_Name, Create_Date_Time_Stamp, Ticket_No }) => {
      const appId = Application_Name;
      const ticketDate = new Date(Create_Date_Time_Stamp);

      if (
        (!cutoffDate || ticketDate >= cutoffDate) &&
        ticketCountMap.hasOwnProperty(appId) &&
        !ticketNoSetMap[appId].has(Ticket_No)
      ) {
        ticketCountMap[appId]++;
        ticketNoSetMap[appId].add(Ticket_No);
      }
    });

    const maxCount = Math.max(...Object.values(ticketCountMap), 1);

    const finalData = Object.entries(ticketCountMap).map(([appId, count]) => ({
      name: appMap[appId] || `Unknown App (${appId})`,
      count,
      percent: Math.round((count / maxCount) * 100),
    }));

    setApplications(finalData);
  }, [selectedDays, rawTicketData, appMap]);

  useEffect(() => {
    const progressBars = document.querySelectorAll(".my-progress");
    progressBars.forEach((bar) => {
      const percentage = parseInt(bar.getAttribute("data-percent"), 10) || 0;
      if (percentage > 0) {
        bar.style.background = `linear-gradient(to right, ${getColorStops(percentage).join(", ")})`;
        bar.style.width = "0%";
        setTimeout(() => {
          bar.style.transition = "width 1s ease-in-out";
          bar.style.width = `${percentage}%`;
        }, 100);
      } else {
        bar.style.background = "#eee";
        bar.style.width = "0%";
      }
    });
  }, [applications]);

  function getColorStops() {
    return ["#ED1C24", "#EC281E", "#EC480E", "#EC5E04"];
  }

  // Prepare data to render: either applications if available, else fallback to appMap or no data
  const dataToRender =
    applications.length > 0
      ? applications
      : Object.values(appMap).length > 0
        ? Object.values(appMap).map((name) => ({ name, count: 0, percent: 0 }))
        : [{ name: "No Data", count: 0, percent: 0 }];

  return (
    <div className="assisvia">
      <div className="assisvia-header d-flex justify-content-between">
        <h1>
          <strong>Assistance Given</strong>
        </h1>
        <div className="selectinput">
          <CustomDropdown
            options={days}
            placeholder="Select Days"
            onChange={handleChange}
            name="days"
            className="selectinput"
            value={selectedDays}
          />
        </div>
      </div>

      <div className="progressmain d-flex flex-column">
        {dataToRender.map((app, index) => (
          <div className="progressbox" key={index}>
            <div className="progressinfo d-flex justify-content-between">
              <span>{app.name}</span>
              <span>{app.count.toLocaleString()}</span>
            </div>
            <div className="progress">
              <div
                className="my-progress"
                data-percent={app.percent}
                style={{
                  width: app.count === 0 ? "0%" : undefined,
                  background: app.count === 0 ? "#eee" : undefined,
                }}
              ></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
